export default __webpack_public_path__ + "static/media/empty-resource.e19ce656.png";